import ProductLayout from '../..'
import { ComponentWithPermissions } from '../../../../../baseComponents/CreateRoutering/types'
import LoaderDecider from '../../../../../baseComponents/LoaderDecider'
import FormRenderer from '../../../../../forms/FormRenderer'
import { FormRender } from '../../../../../forms/FormRenderer/types'
import TwinForm from '../../../../../forms/TwinForm'
import { valueOrDefaultValue } from '../../../../../utils/globals/valueOrDefaultValue'
import useIsLoading from '../../../../../utils/hooks/useIsLoading'
import useLangData from '../../../../../utils/hooks/useLangData'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'
import { getActiveLangs } from '../../../../../utils/reducers/getters'
import { AddLangIdProductModelType, ModifiedProductLangModelType, ProductExtendedTyShort } from '../../../types'
import RelatedProducts from '../../Subcomponents/RelatedProducts'


interface SeoProductProps extends ComponentWithPermissions {
    basicData: ProductExtendedTyShort
    getData: () => Promise<void>
}

const SeoProduct: React.FC<SeoProductProps> = ({ basicData, getData, userPermissions }) => {
    const { t } = useTwinTranslation()
    const { changeLang, selectedLang, data, changeValCurrentLang } = useLangData({ myData: basicData?.ProductLangs, fieldsToLang: ['metaName', 'metaDescription', 'metaKeywords'], keyValue: 'LangId' })
    const { startLoading, endLoading, loading } = useIsLoading()
    const fields: FormRender<ModifiedProductLangModelType> = [
        {
            cols: 1,
            elements: [
                {
                    label: t('metaName', 'Metanombre'),
                    name: 'metaName',
                    component: 'InputWithLabelMargin',
                    lang: selectedLang,
                    value: data?.['metaName'][selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('metaName', name)
                },
                {
                    name: 'metaNameLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.metaName)
                },
            ]
        },
        {
            cols: 1,
            elements: [
                {
                    label: t('metaDescription', 'Metadescripción'),
                    name: 'metaDescription',
                    component: 'TwinEditor',
                    className: 'h-100',
                    defaultValue: data?.['metaDescription'][selectedLang] ?? '',
                    onChange: (name) => changeValCurrentLang('metaDescription', name)
                },
                {
                    name: 'metaDescriptionLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.metaDescription)
                },
                {
                    name: 'metaKeywordsLangs',
                    component: 'InputHidden',
                    value: JSON.stringify(data?.metaKeywords)
                },
                {
                    name: 'id',
                    component: 'InputHidden',
                    value: basicData?.id
                },
            ]
        },
        {
            cols: 1,
            title: t('keywords', 'Palabras clave'),
            elements: [
                {
                    label: t('metakeyword', 'Palabra clave'),
                    name: 'metaDescriptionLangs',
                    component: 'ListAdderStateLess',
                    items: data?.['metaKeywords']?.[selectedLang] ? data?.['metaKeywords']?.[selectedLang]?.split(';') : [],
                    onChange: (value) => changeValCurrentLang('metaKeywords', value.join(';'))
                },
            ]
        }
    ]
    const rightFields: FormRender<AddLangIdProductModelType> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'LangId',
                    label: t('language', 'Idioma'),
                    component: 'CustomSelectWithSearchBar',
                    items: getActiveLangs(),
                    value: selectedLang,
                    onChange: changeLang
                }
            ]
        },
    ]
    const parsedLeftFields = valueOrDefaultValue(fields, userPermissions, basicData)
    const parsedRightFields = valueOrDefaultValue(rightFields, userPermissions, basicData)
    return (
        <TwinForm className='flex flex-auto h-1' action='/api/app/product/updateProduct' onSubmit={() => { endLoading(); getData() }} beforeSubmitHandler={startLoading} onError={endLoading}>
            <LoaderDecider loading={data ? false : true}>
                <ProductLayout basicData={basicData} buttonIsDisabled={loading} userPermissions={userPermissions}>
                    <div className='product_container flex flex-wrap flex-auto'>
                        <div className='flex w-3/4 product_container_left'>
                            <div className='product_container_main flex flex-col flex-auto'>
                                <RelatedProducts {...{ userPermissions, getData }} relatedProducts={basicData?.RelatedProductsParsed} ProductId={basicData?.id} />
                                <FormRenderer sections={parsedLeftFields} antiUnsaveTrigger={true} className='auto-rows-min'/>
                            </div>
                            <div className='vertical_separator_product'></div>
                        </div>
                        <div className='flex flex-col w-1/4 product_container_right'>
                            <FormRenderer sections={parsedRightFields} />
                        </div>
                    </div>
                </ProductLayout>
            </LoaderDecider>
        </TwinForm>
    )
}

export default SeoProduct